export const types = {

    START_LOADING: 'START_LOADING',
    STOP_LOADING: 'STOP_LOADING',

    GET_DEFINITIONS_REQUEST: 'GET_DEFINITIONS_REQUEST',
    GET_DEFINITIONS_SUCCESS: 'GET_DEFINITIONS_SUCCESS',
    GET_DEFINITIONS_FAILURE: 'GET_DEFINITIONS_FAILURE',

    GET_ARTICLE_PROVISIONS_REQUEST: 'GET_ARTICLE_PROVISIONS_REQUEST',
    GET_ARTICLE_PROVISIONS_SUCCESS: 'GET_ARTICLE_PROVISIONS_SUCCESS',
    GET_ARTICLE_PROVISIONS_FAILURE: 'GET_ARTICLE_PROVISIONS_FAILURE',

    GET_INSTRUMENTS_REQUEST: 'GET_INSTRUMENTS_REQUEST',
    GET_INSTRUMENTS_SUCCESS: 'GET_INSTRUMENTS_SUCCESS',
    GET_INSTRUMENTS_FAILURE: 'GET_INSTRUMENTS_FAILURE'
}